/**
 * Normalize post-login navigation targets so OAuth and in-app redirects do not send
 * authenticated users back to marketing routes (e.g. `/`, `/about`).
 */
export function resolvePostLoginPath(
    nextParam: string | null,
    fromPathname: string | undefined
): string {
    const raw = (nextParam || fromPathname || '/app').trim();
    const pathOnly = raw.split('?')[0];
    if (pathOnly === '/' || pathOnly === '/about') return '/app';
    return raw.startsWith('/') ? raw : `/${raw}`;
}
